import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { Button, Icon, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import type { RailRow } from '@/features/adviser-chat/lib/railRow'
import { OperatorAvatar } from './OperatorAvatar'

interface ConversationRailRowProps {
  row: RailRow
  active: boolean
  /** Open conversations carry a heavier title than settled history. */
  emphasized?: boolean
  onSelect: (id: number) => void
}

export const ConversationRailRow = ({
  row,
  active,
  emphasized = false,
  onSelect,
}: ConversationRailRowProps) => (
  <Button
    type="button"
    variant="ghost"
    onClick={() => onSelect(row.id)}
    aria-current={active ? 'page' : undefined}
    className={mtc(
      'h-auto w-full justify-start rounded-[12px] bg-transparent px-3 py-2 text-left hover:bg-moss-50/30 active:bg-moss-50/50',
      active && 'bg-moss-50/50 hover:bg-moss-50/50'
    )}
  >
    <span className="flex w-full items-start gap-2.5">
      {row.operator ? (
        <OperatorAvatar operator={row.operator} />
      ) : (
        <span
          data-testid="rail-row-leading"
          className="flex size-7 shrink-0 items-center justify-center"
        >
          {row.waiting && (
            <Icon
              data-testid="rail-row-waiting-clock"
              icon={faClock}
              color="text-neutral-400"
              className="size-4 shrink-0"
            />
          )}
        </span>
      )}
      <span className="flex min-w-0 flex-1 flex-col">
        <Text
          variant={TypographyStyles.BODY_SM}
          color={TextColors.HEADER}
          className={mtc('truncate w-full', emphasized && 'font-semibold')}
        >
          {row.title}
        </Text>
        <span className="block w-full truncate">
          {row.attention && (
            <Text
              variant={TypographyStyles.LABEL_XS}
              color={TextColors.ORANGE}
              className="inline"
            >
              {row.attention}
            </Text>
          )}
          <Text
            variant={TypographyStyles.BODY_XS}
            color={TextColors.MUTED}
            className="inline"
          >
            {row.attention && row.details.length > 0 && ' · '}
            {row.details.join(' · ')}
          </Text>
        </span>
      </span>
    </span>
  </Button>
)
